var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlarm = function SvgAlarm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4367 20.4357H5.57821C4.8484 20.4357 4.25677 21.027 4.25677 21.7563V23.3618H19.7581V21.7563C19.7581 21.027 19.1665 20.4357 18.4367 20.4357Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8723 19.6052H7.24785L8.07866 10.9878C8.15224 10.2248 8.50622 9.5216 9.07537 9.00778C9.62005 8.51604 10.3242 8.12217 11.058 8.1048C11.058 8.1048 9.30127 9.21516 9.13804 11.0898C8.95251 13.2204 8.60097 19.6052 8.60097 19.6052H18.1426L17.2663 10.6083C17.0931 8.59649 15.4085 7.05153 13.3879 7.05153H10.6562C8.63992 7.05153 6.95734 8.59019 6.77879 10.5973L5.8723 19.6052Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83205 12H0.511074C0.2292 12 0 12.229 0 12.5107C0 12.7923 0.2292 13.0213 0.511074 13.0213H3.83205C4.11392 13.0213 4.34312 12.7923 4.34312 12.5107C4.34312 12.229 4.11392 12 3.83205 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03379 6.51811L3.55922 4.30466C3.34919 4.11679 3.02558 4.13467 2.83764 4.34452C2.6497 4.55438 2.66766 4.87778 2.87769 5.06565L5.35225 7.27909C5.56229 7.46696 5.88589 7.44909 6.07384 7.23923C6.26178 7.02938 6.24382 6.70598 6.03379 6.51811Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1679 11.9934H23.4889C23.7708 11.9934 24 12.2224 24 12.5041C24 12.7857 23.7708 13.0147 23.4889 13.0147H20.1679C19.8861 13.0147 19.6569 12.7857 19.6569 12.5041C19.6569 12.2224 19.8861 11.9934 20.1679 11.9934Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9662 6.51153L20.4408 4.29809C20.6508 4.11022 20.9744 4.12809 21.1624 4.33795C21.3503 4.5478 21.3323 4.8712 21.1223 5.05907L18.6477 7.27252C18.4377 7.46039 18.1141 7.44251 17.9262 7.23266C17.7382 7.0228 17.7562 6.6994 17.9662 6.51153Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4965 1.14906V4.46797C11.4965 4.74967 11.7256 4.97873 12.0075 4.97873C12.2893 4.97873 12.5184 4.74967 12.5184 4.46797V1.14906C12.5184 0.867363 12.2893 0.638306 12.0075 0.638306C11.7256 0.638306 11.4965 0.867363 11.4965 1.14906Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlarm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alarm.aef35ff9.svg";
export { ForwardRef as ReactComponent };